import React from 'react'
import LoginLayoutPP from "../login/LoginLayoutPP";
import LogoPP from "../common/LogoPP";
import { ClientLogo } from "@cxagroup/casper";
import { changePassword, fetchPasswordPolicy } from "actions/changePasswordActions";
import ChangePasswordForm from "./ChangePasswordForm";
import { removeResetExpirePasswordAction } from "actions/loginActions";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { RouteMap } from "components/common/navigation/routeMap";

const ChangePasswordPagePP = (props) => {

    const {
        changePassword,
        removeResetExpirePasswordAction,
        user: { pendingAuthActions, employee, hrAdmin } = {},
        isAuthenticated,
        submitted,
        logoUrl,
        push,
        fetchPasswordPolicy,
        resetExpiredPasswordMode,
        client,
      } = props;

      const doRedirect = () => {
        if (isAuthenticated) {
          if (submitted) {
            if (pendingAuthActions.length > 0) {
              setTimeout(() => removeResetExpirePasswordAction(), 3000);
            }
            push("/logout");
          } else if (hrAdmin && employee) {
            // Redirect to CXA dashboard page when impersonate employee is on-going
            // HR should not be able to access change password page
            // eslint-disable-next-line xss/no-location-href-assign
            location.href = RouteMap.CXAMain;
          }
        }
      };
    
      React.useEffect(() => {
        fetchPasswordPolicy(client && { clientName: client });
        doRedirect();
      },  [submitted, fetchPasswordPolicy]);


  return resetExpiredPasswordMode ? (  
    <LoginLayoutPP isFlex={true}>
        <div className="login__brand" style={{ width: "100%" }}>
        {logoUrl ? <ClientLogo client={client} logoUrl={logoUrl} size="large" /> : <LogoPP width={240}/>}
        </div>
        <div className="form-container-password">
            <ChangePasswordForm onSubmit={changePassword} {...props} />
        </div>
    </LoginLayoutPP>
  ) : (
    <div className="form-container-password">
      <ChangePasswordForm onSubmit={changePassword} {...props} />
    </div>
  )
}

ChangePasswordPagePP.propTypes = {
    client: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    logoUrl: PropTypes.string,
    changePassword: PropTypes.func.isRequired,
    fetchPasswordPolicy: PropTypes.func,
    push: PropTypes.func,
    policyDescription: PropTypes.string,
    changeSelectedLanguage: PropTypes.func,
    resetExpiredPasswordMode: PropTypes.bool
  };
  
  const mapStateToProps = (
    {
      app: { client, clientName },
      changePassword: { response, submitting, submitted, policyDescription },
      login: { isAuthenticated, user },
      common: { isFetching, logoUrl }
    },
    { location: { pathname } }
  ) => ({
    client,
    response,
    logoUrl,
    submitting,
    submitted,
    policyDescription,
    isAuthenticated,
    user,
    pathname,
    resetExpiredPasswordMode: user.pendingAuthActions.length > 0
  });
  
  const mapDispatchToProps = (dispatch) => ({
    changePassword: (data) => dispatch(changePassword(data)),
    fetchPasswordPolicy: (data) => dispatch(fetchPasswordPolicy(data)),
    removeResetExpirePasswordAction: () =>
      dispatch(removeResetExpirePasswordAction())
  });
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChangePasswordPagePP);


// WEBPACK FOOTER //
// ./components/password/ChangePasswordPagePP.js